<template>
  <PageLayout>
    <template v-slot:header>
      <div class="ui padded grid">
        <div class="row">
          <div class="sixteen wide column">
            <Breadcrumb>
              <a class="section" v-go-back="'contracts'">Contratos</a>
              <i class="right chevron icon divider"></i>
              <router-link
                class="section"
                :to="`/contracts/${$route.params.contract_id}`"
              >
                {{ $route.params.contract_id }}
              </router-link>
              <i class="right chevron icon divider"></i>
              <div class="active section">
                <div class="neutral">Autorizações de procedimentos</div>
              </div>
            </Breadcrumb>
          </div>
        </div>
      </div>
    </template>
    <template v-slot:main>
      <div class="ui padded grid">
        <div class="row">
          <div class="sixteen wide column">
            <h2 class="ui header">
              <div class="sub header">Saldo atual</div>
              {{ contract.balance | money }}
            </h2>
            <Grid
              ref="grid"
              resource="procedure_authorizations"
              @refresh="loadData()"
              @page="n => loadData(n)"
            />
          </div>
        </div>
      </div>
    </template>
  </PageLayout>
</template>

<script>
import Api from '@/resources/Api';
import Breadcrumb from '@/components/breadcrumb';
import PageLayout from '@/layouts/page_layout';
import Grid from './widgets/grid';

export default {
  name: 'services',
  components: { Grid, Breadcrumb, PageLayout },

  data() {
    return {
      contract: { balance: null },
      searchForm: {
        description: null,
        cod: null
      },
      query: {}
    };
  },

  mounted() {
    this.loadData();
  },

  methods: {
    async loadData() {
      try {
        this.$refs.grid.toggleLoading();

        const query = {
          q: {
            contract_id_eq: this.$route.params.contract_id,
            s: ['created desc']
          }
        };

        const contractResponse = await Api.contracts.fetch(
          this.$route.params.contract_id
        );
        this.contract = contractResponse.data.contract;

        const procedureAuthorizationsReponse = await Api.procedureAuthorizations.search(
          query
        );
        const procedureAuthorizations =
          procedureAuthorizationsReponse.data.procedure_authorizations;

        this.$refs.grid.setData(
          procedureAuthorizations,
          this.$route.params.contract_id
        );
      } catch (e) {
        this.$toast.show('Erro ao carregar dados', 'error');
        throw e;
      } finally {
        this.$refs.grid.toggleLoading();
      }
    }
  }
};
</script>
